const isTypeCrossdocking = serviceRegionInfo =>
  serviceRegionInfo?.serviceRegionType === 'SERVICE_REGION_TYPE_CROSS_DOCKING';

const isTypeDropOff = serviceRegionInfo =>
  serviceRegionInfo?.serviceRegionType === 'SERVICE_REGION_TYPE_DROPOFF';

export { isTypeCrossdocking, isTypeDropOff };
